var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "show-or-hide-button",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.toggle.apply(null, arguments)
        },
      },
    },
    [
      _c("span", { class: [_vm.icon, "show-or-hide-icon"] }),
      _c("span", { staticClass: "toggle-text" }, [_vm._v(_vm._s(_vm.text))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }